﻿export default class DataLayerFileDownload {
    constructor(name, format, type, url) {
        this.name = name;
        this.format = format;
        this.type = type;
        this.url = url;
    }
}